import { FieldType } from 'constants/formGenerator';
import { programLoanTypeOptions } from 'constants/options';

export const programConfigFields = {
  programLoanType: {
    type: FieldType.SELECT,
    nameInModel: 'programLoanType',
    inputProps: {
      options: programLoanTypeOptions,
    },
  },
};
